import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './RCUISingleSelect.scss';

class Options extends Component {
  constructor(props) {
    super(props);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount() {
    this.focusSelectedOption();
  }

  onKeyDown(event, optionIndex) {
    switch (event.keyCode) {
      case 38: this.keyboardNavigateHandler(event, optionIndex - 1); break; // Up arrow key
      case 40: this.keyboardNavigateHandler(event, optionIndex + 1); break; // Down arrow key
      default: break;
    }
  }

  focusSelectedOption() {
    const { options, selectedOption } = this.props;
    if (!options || options.length === 0) { return; }
    if (selectedOption) {
      const optionIndex = options.map(option => option.value).indexOf(selectedOption.value);
      this.focusWithIndex(optionIndex);
    } else {
      this.focusWithIndex(0);
    }
  }

  focusWithIndex(index) {
    const button = this.buttonRefs[index];
    if (button) { button.focus(); }
  }

  populateOptionListClassName() {
    const { optionListClassName } = this.props;
    return [styles.optionList, optionListClassName].join(' ');
  }

  populateOptionItemClassName(option) {
    const { selectedOption, optionItemClassName } = this.props;
    const optionItemClassNames = [styles.optionItem, optionItemClassName].join(' ');
    if (!option || !selectedOption || option.value !== selectedOption.value) {
      return optionItemClassNames;
    }
    return `${optionItemClassNames} selected`;
  }

  keyboardNavigateHandler(event, index) {
    event.preventDefault();
    this.focusWithIndex(index);
  }

  buttonRefs = []

  render() {
    const { options, onSelect, customRenderer } = this.props;
    return (
      <ul className={this.populateOptionListClassName()}>
        {
          options.map((option, index) => (
            <li key={`option-${index}`}>
              <button
                className={this.populateOptionItemClassName(option)}
                onClick={() => onSelect(option)}
                onKeyDown={(e) => { this.onKeyDown(e, index); }}
                ref={(c) => { this.buttonRefs[index] = c; }}
                type="button"
              >
                {customRenderer ? customRenderer(option) : option.displayText}
              </button>
            </li>
          ))
        }
      </ul>
    );
  }
}

export const OptionType = PropTypes.shape({
  displayText: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
});

Options.propTypes = {
  options: PropTypes.arrayOf(OptionType).isRequired,
  selectedOption: OptionType,
  onSelect: PropTypes.func.isRequired,
  optionListClassName: PropTypes.string,
  optionItemClassName: PropTypes.string,
  customRenderer: PropTypes.func,
};

export default Options;
